const UTM_KEYS = ["utm_source", "utm_campaign", "utm_content", "utm_medium"];
const STORAGE_KEY = "ps_utm";

/**
 * Reads UTM params from the current URL and saves them to localStorage.
 * Only overwrites if the new URL actually contains UTM params (so direct
 * visits after an ad click don't erase the original attribution).
 */
export function captureUtmParams() {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_KEYS.some((k) => params.has(k));
  if (!hasUtm) return;

  const utm = { utm_params: window.location.search };
  UTM_KEYS.forEach((k) => {
    utm[k] = params.get(k) ?? null;
  });

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  } catch {
    // localStorage unavailable (private mode, etc.)
  }
}

/**
 * Returns stored UTM params, or an empty object if none were ever captured.
 */
export function getStoredUtmParams() {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
